/* eslint-disable import/no-cycle */
import { createRouter, createWebHistory } from 'vue-router';
import RegistrationFirstName from '@/modules/registration/view-model/RegistrationFirstName.vue';
import RegistrationLastName from '@/modules/registration/view-model/RegistrationLastName.vue';
import RegistrationSearchName from '@/modules/registration/view-model/RegistrationSearchName.vue';
import RegistrationEmail from '@/modules/registration/view-model/RegistrationEmail.vue';
import Healthcare from '@/modules/registration/view-model/Healthcare.vue';
import RegistrationPassword from '@/modules/registration/view-model/RegistrationPassword.vue';
import RegistrationProfession from '@/modules/registration/view-model/RegistrationProfession.vue';
import RegistrationProfessionDetail from '@/modules/registration/view-model/RegistrationProfessionDetail.vue';
import RegistrationSpecialities from '@/modules/registration/view-model/RegistrationSpecialities.vue';
import RegistrationNPI from '@/modules/registration/view-model/RegistrationNPI.vue';
import RegistrationSearchNPI from '@/modules/registration/view-model/RegistrationSearchNPI.vue';
import RegistrationFinishedVue from '@/modules/registration/view-model/RegistrationFinished.vue';
import RegistrationAgreement from '@/modules/registration/view-model/RegistrationAgreement.vue';
import RegistrationFieldWork from '@/modules/registration/view-model/RegistrationFieldWork.vue';
import RegistrationFieldSpecialty from '@/modules/registration/view-model/RegistrationFieldSpecialty.vue';
import RegistrationFieldNurse from '@/modules/registration/view-model/RegistrationFieldNurse.vue';
import RegistrationFieldVendor from '@/modules/registration/view-model/RegistrationFieldVendor.vue';
import RegistrationVerifyNumber from '@/modules/registration/view-model/RegistrationVerifyNumber.vue';
import RegistrationVerifyNumberCode from '@/modules/registration/view-model/RegistrationVerifyNumberCode.vue';
import ProfileAbout from '@/modules/profile/view-models/ProfileAbout.vue';
import ProfileEdit from '@/modules/profile/view-models/ProfileEdit.vue';
import SpacesContacts from '@/modules/spaces/view-models/SpacesContacts.vue';
import SpacesContactsAdd from '@/modules/spaces/view-models/SpacesContactsAdd.vue';
import SpacesContactsManage from '@/modules/spaces/view-models/SpacesContactsManage.vue';
import SpacesGroups from '@/modules/spaces/view-models/Groups/SpacesGroups.vue';
import GroupsAddName from '@/modules/spaces/view-models/Groups/GroupsAddName.vue';
import GroupsAddInfo from '@/modules/spaces/view-models/Groups/GroupsAddInfo.vue';
import GroupsAddSettings from '@/modules/spaces/view-models/Groups/GroupsAddSettings.vue';
import SpacesGroupsAddMembers from '@/modules/spaces/view-models/SpacesGroupsAddMembers.vue';
import SpacesSettleTeam from '@/modules/spaces/view-models/SpacesSettleTeam.vue';
import SpacesGroupOverview from '@/modules/spaces/view-models/SpacesGroupOverview.vue';
import MessagesMy from '@/modules/messages/view-models/MessagesMy.vue';
import MessagesId from '@/modules/messages/view-models/MessagesId.vue';

import UserService from '@/services/UserService';
import LocalStorageService from '@/services/LocalStorageService';
import AuthService from '@/modules/auth/services/AuthService';
import { useMainStore } from '@/store/mainStore';
import { NAVIGATION_PAGES, REGISTRATION_STATE, USER_STATUS } from '@/types/enums';
import { IToken } from '@/types/interfaces';
import SpacesEditGroup from '@/modules/spaces/view-models/SpacesEditGroup.vue';
import SpacesYourGroups from '@/modules/spaces/view-models/SpacesYourGroups.vue';
import SpacesGroupsYouOwn from '@/modules/spaces/view-models/SpacesGroupsYouOwn.vue';
import SpacesGroupsYouAreIn from '@/modules/spaces/view-models/SpacesGroupsYouAreIn.vue';
import MessagesGroupId from '@/modules/messages/view-models/MessagesGroupId.vue';
import MonitoringService from '@/services/MonitoringService';
import ChangePassword from '@/modules/settings/components/ChangePassword.vue';
import Notifications from '@/modules/settings/components/Notifications.vue';
import SharingSettings from '@/modules/settings/components/SharingSettings.vue';
import Help from '@/modules/settings/components/Help.vue';
import Journey from '@/modules/settings/components/Journey.vue';
import UIPage from '@/modules/ui-view/UIPage.vue';

import Welcome from '@/modules/welcome/view-model/Welcome.vue';
import Join from '@/modules/welcome/view-model/Join.vue';
import Login from '@/modules/auth/view-model/Login.vue';
import EmailConfirm from '@/modules/auth/view-model/EmailConfirm.vue';
import PasswordResetMain from '@/modules/reset-pass/view-model/PasswordResetMain.vue';
import LoginByLink from '@/modules/reset-pass/view-model/LoginByLink.vue';
import PasswordResetValidate from '@/modules/reset-pass/view-model/PasswordResetValidate.vue';
import PasswordResetChange from '@/modules/reset-pass/view-model/PasswordResetChange.vue';
import PasswordResetError from '@/modules/reset-pass/view-model/PasswordResetError.vue';
import PasswordResetSuccess from '@/modules/reset-pass/view-model/PasswordResetSuccess.vue';
import Registration from '@/modules/registration/view-model/Registration.vue';
import Profile from '@/modules/profile/layouts/Profile.vue';
import Spaces from '@/modules/spaces/layouts/Spaces.vue';
import Alerts from '@/modules/alerts/view-model/Alerts.vue';

import Drive from '@/modules/drive/layout/Drive.vue';
import DriveMain from '@/modules/drive/view-models/DriveMain.vue';
import DriveNetwork from '@/modules/drive/view-models/DriveNetwork.vue';
import DriveCaseEdit from '@/modules/drive/view-models/DriveCaseEdit.vue';
import DriveCaseView from '@/modules/drive/view-models/DriveCaseView.vue';
import DriveCasePublicView from '@/modules/drive/view-models/DriveCasePublicView.vue';
import DriveAllCases from '@/modules/drive/view-models/DriveAllCases.vue';
import DriveAllPublicCases from '@/modules/drive/view-models/DriveAllPublicCases.vue';
import DriveAllPhotos from '@/modules/drive/view-models/DriveAllPhotos.vue';
import DriveAllMixed from '@/modules/drive/view-models/DriveAllMixed.vue';
import DriveFolder from '@/modules/drive/view-models/DriveFolder.vue';
import DriveCreateCase from '@/modules/drive/view-models/DriveCreateCase.vue';

import Messages from '@/modules/messages/layout/Messages.vue';
import Settings from '@/modules/settings/view-model/Settings.vue';
import RetrieveApiKey from '@/modules/settings/view-model/RetrieveApiKey.vue';
import Payment from '@/modules/payment/view-model/Payment.vue';
import Error404 from '@/modules/errors/view-models/Error404.vue';
import Error403 from '@/modules/errors/view-models/Error403.vue';
import ErrorDeploy from '@/modules/errors/view-models/ErrorDeploy.vue';
import ErrorNoStatus from '@/modules/errors/view-models/ErrorNoStatus.vue';

declare module 'vue-router' {
  interface RouteMeta {
    title?: string
    customTitle?: boolean
    subtitle?: string
    subtitleLink?: string
    requires?: USER_STATUS[]
    error?: boolean
    hideHeader?: boolean
    navigationPage?: NAVIGATION_PAGES
    hideAppButton?: boolean
    hideBottomNav?: boolean
    hideFooter?: boolean
    hideHeaderSearch?: boolean
    showGroupImage?: boolean
    manualScroll?: boolean
    hideBackStep?: boolean
    backText?: string
    backArrow?: boolean
    stepBackTo?: string
    autoSave?: boolean
    isNetwork?: boolean
    isUserPublicCase?: boolean
  }
}

const routes = [
  {
    path: '/',
    name: 'Welcome',
    component: Welcome,
    meta: {
      navigationPage: NAVIGATION_PAGES.HOME,
      requires: [USER_STATUS.LOGGED_IN, USER_STATUS.CONFIRM_EMAIL, USER_STATUS.COMPLETED],
    },
  },
  {
    path: '/_ui',
    name: 'UIElementPage',
    component: UIPage,
    meta: {
      requires: [USER_STATUS.LOGGED_IN, USER_STATUS.CONFIRM_EMAIL, USER_STATUS.COMPLETED],
    },
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      hideFooter: true,
      // title: 'login.page.title',
    },
  },
  {
    path: '/email-confirm',
    name: 'EmailConfirm',
    component: EmailConfirm,
    meta: { hideFooter: true },
  },
  {
    path: '/password-reset',
    name: 'ResetPassword',
    component: PasswordResetMain,
    meta: { hideFooter: true },
  },
  {
    path: '/login-by-link',
    name: 'LoginByLink',
    component: LoginByLink,
    meta: { hideFooter: true },
  },
  {
    path: '/password-reset-validate',
    name: 'ResetPasswordValidate',
    component: PasswordResetValidate,
    beforeEnter: (to, from, next) => {
      const tokenParam = to.query.token?.toString();
      AuthService.confirmPasswordChange({ token: tokenParam } as IToken).then((response) => {
        if (response.success) {
          next('/password-reset-change');
        } else {
          next('/password-reset-error');
        }
      });
    },
  },
  {
    path: '/password-reset-change', // temp route - compose with validate in one component
    name: 'PasswordResetChange',
    component: PasswordResetChange,
    meta: { hideHeader: true, hideFooter: true },
    beforeEnter: (to, from, next) => {
      if (to.redirectedFrom?.name === 'ResetPasswordValidate') {
        next();
      } else {
        next('/login');
      }
    },
  },
  {
    path: '/password-reset-success',
    name: 'ResetPasswordSuccess',
    component: PasswordResetSuccess,
    meta: { hideHeader: true, hideFooter: true },
  },
  {
    path: '/password-reset-error',
    name: 'ResetPasswordError',
    component: PasswordResetError,
    meta: { hideHeader: true, hideFooter: true },
  },
  {
    path: '/registration',
    name: 'Registration',
    component: Registration,
    meta: {
      hideFooter: true,
    },
    children: [
      {
        path: 'step-1',
        name: 'RegistrationEmail',
        component: RegistrationEmail,
        meta: {
          backText: 'registration.step1.cancel.button',
          backArrow: true,
          backPath: '/',
          title: 'registration.title.step1',
          showRegistrationLogin: true,
        },
      },
      {
        path: 'healthcare',
        name: 'Healthcare',
        component: Healthcare,
        meta: {
          backText: 'registration.button.cancel',
          backArrow: true,
          title: 'registration.title.healthcare',
          requires: [USER_STATUS.CONFIRM_PHONE_NUMBER, USER_STATUS.NOT_REGISTERED],
        },
      },
      {
        path: 'step-2',
        name: 'RegistrationFirstName',
        component: RegistrationFirstName,
        meta: {
          backText: 'registration.step2.back.button',
          backArrow: true,
          cancelRegistration: true,
          title: 'registration.title.step2',
          requires: [USER_STATUS.CONFIRM_PHONE_NUMBER, USER_STATUS.NOT_REGISTERED],
        },
      },
      {
        path: 'step-2a',
        name: 'RegistrationLastName',
        component: RegistrationLastName,
        meta: {
          backText: 'Back',
          backArrow: true,
          title: 'What’s your last name?',
          requires: [USER_STATUS.CONFIRM_PHONE_NUMBER, USER_STATUS.NOT_REGISTERED],
        },
      },
      {
        path: 'step-3',
        name: 'RegistrationProfession',
        component: RegistrationProfession,
        meta: {
          backText: 'registration.step3.back.button',
          backArrow: true,
          title: 'registration.title.step-3',
          requires: [USER_STATUS.CONFIRM_PHONE_NUMBER, USER_STATUS.NOT_REGISTERED],
        },
      },
      {
        path: 'step-3a',
        name: 'RegistrationProfessionDetailOther',
        component: RegistrationProfessionDetail,
        meta: {
          backText: 'registration.step-3a.back.button',
          backArrow: true,
          title: 'registration.title.step-3a',
          requires: [USER_STATUS.CONFIRM_PHONE_NUMBER, USER_STATUS.NOT_REGISTERED],
        },
      },
      {
        path: 'step-3b',
        name: 'RegistrationProfessionDetailNursing',
        component: RegistrationProfessionDetail,
        meta: {
          backText: 'registration.step-3b.back.button',
          backArrow: true,
          title: 'registration.title.step-3b',
          label: 'registration.step-3b.label',
          placeholder: 'registration.step-3b.placeholder',
          requires: [USER_STATUS.CONFIRM_PHONE_NUMBER, USER_STATUS.NOT_REGISTERED],
        },
      },
      {
        path: 'step-3b-1',
        name: 'RegistrationSpecialities',
        component: RegistrationSpecialities,
        meta: {
          backText: 'registration.step-3b-1.back.button',
          backArrow: true,
          title: 'registration.title.step-3b-1',
          requires: [USER_STATUS.CONFIRM_PHONE_NUMBER, USER_STATUS.NOT_REGISTERED],
        },
      },
      {
        path: 'step-3c',
        name: 'RegistrationProfessionDetailAlliedHealth',
        component: RegistrationProfessionDetail,
        meta: {
          backText: 'registration.step-3c.back.button',
          backArrow: true,
          title: 'registration.title.step-3c',
          requires: [USER_STATUS.CONFIRM_PHONE_NUMBER, USER_STATUS.NOT_REGISTERED],
          label: 'registration.step-3c.label',
          placeholder: 'registration.step-3c.placeholder',
        },
      },
      {
        path: 'step-3d',
        name: 'RegistrationProfessionDetailDental',
        component: RegistrationProfessionDetail,
        meta: {
          backText: 'registration.step-3d.back.button',
          backArrow: true,
          title: 'registration.title.step-3d',
          requires: [USER_STATUS.CONFIRM_PHONE_NUMBER, USER_STATUS.NOT_REGISTERED],
        },
      },
      {
        path: 'step-3e',
        name: 'RegistrationProfessionDetailMedical',
        component: RegistrationProfessionDetail,
        meta: {
          backText: 'registration.step-3e.back.button',
          backArrow: true,
          title: 'registration.title.step-3e',
          requires: [USER_STATUS.CONFIRM_PHONE_NUMBER, USER_STATUS.NOT_REGISTERED],
        },
      },
      {
        path: 'step-4',
        name: 'RegistrationSearchName',
        component: RegistrationSearchName,
        meta: {
          backText: 'registration.backtext.step4',
          backArrow: true,
          title: 'registration.title.step4',
          showRegistrationLogin: false,
          requires: [USER_STATUS.CONFIRM_PHONE_NUMBER, USER_STATUS.NOT_REGISTERED],
        },
      },
      {
        path: 'step-4a',
        name: 'RegistrationNPI',
        component: RegistrationNPI,
        meta: {
          backText: 'Back',
          backArrow: true,
          title: 'registration.title.step4a',
          subtitleLink: 'https://www.google.com.ua/',
          requires: [USER_STATUS.CONFIRM_PHONE_NUMBER, USER_STATUS.NOT_REGISTERED],
        },
      },
      {
        path: 'step-4b',
        name: 'RegistrationSearchNPI',
        component: RegistrationSearchNPI,
        meta: {
          backText: 'Back',
          backArrow: true,
          title: 'Is this you? ',
          requires: [USER_STATUS.CONFIRM_PHONE_NUMBER, USER_STATUS.NOT_REGISTERED],
        },
      },
      {
        path: 'step-4e',
        name: 'RegistrationSearchNPIError',
        component: RegistrationNPI,
        meta: {
          backText: 'Back',
          backArrow: true,
          title: 'Sorry!',
          subtitle: 'We couldn’t find anybody with that NPI number.',
          error: true,
          requires: [USER_STATUS.CONFIRM_PHONE_NUMBER, USER_STATUS.NOT_REGISTERED],
        },
      },
      {
        path: 'step-5',
        name: 'RegistrationFieldWork',
        component: RegistrationFieldWork,
        meta: {
          backText: 'registration.step3.back.button',
          backArrow: true,
          title: 'registration.title.step-5',
          field: 'work',
          requires: [USER_STATUS.CONFIRM_PHONE_NUMBER, USER_STATUS.NOT_REGISTERED],
        },
      },
      {
        path: 'step-5a',
        name: 'RegistrationFieldNurse',
        component: RegistrationFieldNurse,
        meta: {
          backText: 'registration.step3.back.button',
          backArrow: true,
          title: 'registration.title.step-5a',
          field: 'nurseField',
          requires: [USER_STATUS.CONFIRM_PHONE_NUMBER, USER_STATUS.NOT_REGISTERED],
        },
      },
      {
        path: 'step-5b',
        name: 'RegistrationFieldSpecialty',
        component: RegistrationFieldSpecialty,
        meta: {
          backText: 'registration.step3.back.button',
          backArrow: true,
          title: 'registration.title.step-5b',
          field: 'specialityField',
          requires: [USER_STATUS.CONFIRM_PHONE_NUMBER, USER_STATUS.NOT_REGISTERED],
        },
      },
      {
        path: 'step-5c',
        name: 'RegistrationFieldVendor',
        component: RegistrationFieldVendor,
        meta: {
          backText: 'registration.step3.back.button',
          backArrow: true,
          title: 'registration.title.step-5c',
          field: 'specialityField',
          requires: [USER_STATUS.CONFIRM_PHONE_NUMBER, USER_STATUS.NOT_REGISTERED],
        },
      },
      {
        path: 'step-6',
        name: 'RegistrationPassword',
        component: RegistrationPassword,
        meta: {
          backText: 'Back',
          backArrow: true,
          title: 'Set your password',
          subtitle: 'Password must be at leats 6 characters.',
        },
      },
      {
        path: 'step-7',
        name: 'RegistrationVerifyNumber',
        component: RegistrationVerifyNumber,
        meta: {
          backText: 'Back',
          backArrow: true,
          title: 'registration.step-7.title',
          subtitle: 'registration.step-7.subtitle',
          requires: [USER_STATUS.CONFIRM_PHONE_NUMBER, USER_STATUS.NOT_REGISTERED],
        },
      },
      {
        path: 'step-7a',
        name: 'RegistrationVerifyNumberCode',
        component: RegistrationVerifyNumberCode,
        meta: {
          backText: 'Back',
          backArrow: true,
          title: 'registration.step-7.title',
          subtitle: 'registration.step-7.subtitle',
          requires: [USER_STATUS.CONFIRM_PHONE_NUMBER],
        },
      },
      {
        path: 'step-8',
        name: 'RegistrationAgreement',
        component: RegistrationAgreement,
        meta: {
          backText: 'Back',
          // backArrow: true,
          showRegistrationLogin: true,
        },
      },
      {
        path: 'done',
        name: 'RegistrationFinished',
        component: RegistrationFinishedVue,
      },
      {
        path: '',
        redirect: () => '/registration/step-1',
      },
    ],
  },
  {
    path: '/profile',
    name: 'Profile',
    component: Profile,
    meta: {
      requires: [USER_STATUS.LOGGED_IN, USER_STATUS.CONFIRM_EMAIL, USER_STATUS.COMPLETED],
    },
    children: [
      {
        path: 'my/about',
        name: 'ProfileAbout',
        component: ProfileAbout,
        meta: {
          title: 'profile.title',
          // backText: 'Home',
          backArrow: true,
          stepBackTo: '/',
          navigationPage: NAVIGATION_PAGES.PROFILE_MY,
        },
      },
      {
        path: 'my/edit',
        name: 'ProfileEdit',
        component: ProfileEdit,
        meta: {
          title: 'Edit Profile', backText: 'Cancel',
        },
      },
      {
        path: ':id',
        name: 'ProfileForeignAbout',
        component: ProfileAbout,
        meta: {
          title: 'foreign.profile.title',
          backArrow: true,
          navigationPage: NAVIGATION_PAGES.PROFILE_FOREIGN,
        },
      },
      {
        path: '',
        redirect: () => '/profile/my/about',
      },
    ],
  },
  {
    path: '/spaces',
    name: 'Spaces',
    component: Spaces,
    meta: { requires: [USER_STATUS.LOGGED_IN, USER_STATUS.CONFIRM_EMAIL, USER_STATUS.COMPLETED] },
    children: [
      {
        path: 'contacts',
        name: 'SpacesContacts',
        component: SpacesContacts,
        meta: {
          navigationPage: NAVIGATION_PAGES.SPACES_CONTACTS,
          title: 'contacts.title',
          // backText: 'contacts.backtext',
          backArrow: true,
          hideAppButton: false,
        },
      },
      {
        path: 'add',
        name: 'SpacesContactsAdd',
        component: SpacesContactsAdd,
        meta: {
          navigationPage: NAVIGATION_PAGES.SPACES_ADD_CONTACTS,
          title: 'contacts.add.contacts',
          subtitle: 'Search by name, specialty, location, or NPI Number',
          backText: 'contacts.add.contacts.cancel',
          hideAppButton: true,
          hideBottomNav: true,
          manualScroll: true,
        },
      },
      {
        path: 'manage',
        name: 'SpacesContactsManage',
        component: SpacesContactsManage,
        meta: {
          navigationPage: NAVIGATION_PAGES.SPACES_MANAGE,
          title: 'contacts.manage',
          hideAppButton: true,
          hideBottomNav: true,
          hideFooter: true,
        },
      },
      {
        path: 'groups',
        name: 'SpacesGroups',
        component: SpacesGroups,
        meta: { navigationPage: NAVIGATION_PAGES.SPACES_GROUPS_MAIN, title: 'Groups' },
      },
      {
        path: 'groups/add-name',
        name: 'SpacesGroupsAddName',
        component: GroupsAddName,
        meta: {
          navigationPage: NAVIGATION_PAGES.SPACES_GROUP_NAME,
          backText: 'Cancel',
          hideAppButton: true,
          hideBottomNav: true,
          title: 'Create Group',
          hideHeaderSearch: true,
        },
      },
      {
        path: 'groups/add-info',
        name: 'SpacesGroupsAddInfo',
        component: GroupsAddInfo,
        meta: {
          navigationPage: NAVIGATION_PAGES.SPACES_GROUP_INFO,
          // backText: 'Back',
          backArrow: true,
          hideAppButton: true,
          hideBottomNav: true,
          title: 'Group Info',
          hideHeaderSearch: true,
        },
      },
      {
        path: 'groups/add-settings',
        name: 'SpacesGroupsAddSettings',
        component: GroupsAddSettings,
        meta: {
          navigationPage: NAVIGATION_PAGES.SPACES_GROUP_SETTINGS,
          // backText: 'Back',
          backArrow: true,
          hideAppButton: true,
          hideBottomNav: true,
          title: 'Group Settings',
          hideHeaderSearch: true,
        },
      },
      {
        path: 'groups/add-members',
        name: 'SpacesGroupsAddMembers',
        component: SpacesGroupsAddMembers,
        meta: {
          navigationPage: NAVIGATION_PAGES.SPACES_GROUPS,
          // backText: 'Back',
          backArrow: true,
          hideAppButton: true,
          hideBottomNav: true,
          title: 'Add Members',
          hideHeaderSearch: true,
        },
      },
      {
        path: 'groups/settle-team',
        name: 'SpacesSettleTeam',
        component: SpacesSettleTeam,
        meta: {
          navigationPage: NAVIGATION_PAGES.SPACES_SETTLE,
          hideAppButton: true,
          hideBottomNav: true,
          title: 'Settle Team',
          hideHeaderSearch: true,
          showGroupImage: true,
        },
      },
      {
        path: 'groups/group/:id',
        name: 'SpacesGroupOverview',
        component: SpacesGroupOverview,
        meta: {
          navigationPage: NAVIGATION_PAGES.SPACES_GROUPS_OVERVIEW,
          hideAppButton: true,
          hideBottomNav: true,
          title: 'Team Name',
          hideHeader: true,
          hideHeaderSearch: true,
          showGroupImage: true,
          backText: 'Groups',
          backArrow: true,
        },
      },
      {
        path: 'groups/group/edit/:id',
        name: 'SpacesEditGroup',
        component: SpacesEditGroup,
        meta: {
          navigationPage: NAVIGATION_PAGES.SPACES_GROUPS_EDIT,
          hideAppButton: true,
          hideBottomNav: true,
          title: 'Edit Group',
          hideHeaderSearch: true,
          showGroupImage: true,
          // backText: 'Back',
          backArrow: true,
        },
      },
      {
        path: 'groups/view-my',
        name: 'SpacesYourGroups',
        component: SpacesYourGroups,
        meta: {
          hideAppButton: true,
          hideBottomNav: true,
          title: 'Your Groups',
          hideHeaderSearch: true,
          // backText: 'Groups',
          backArrow: true,
        },
      },
      {
        path: 'groups/view-my-own',
        name: 'SpacesGroupsYouOwn',
        component: SpacesGroupsYouOwn,
        meta: {
          hideAppButton: true,
          hideBottomNav: true,
          title: 'Groups You Own',
          hideHeaderSearch: true,
          backArrow: true,
        },
      },
      {
        path: 'groups/you-are-in',
        name: 'SpacesGroupsYouAreIn',
        component: SpacesGroupsYouAreIn,
        meta: {
          hideAppButton: true,
          hideBottomNav: true,
          title: 'Groups You\'re In',
          hideHeaderSearch: true,
          backArrow: true,
        },
      },
      {
        path: '',
        redirect: () => '/spaces/contacts',
      },
    ],
  },
  {
    path: '/alerts',
    name: 'Alerts',
    component: Alerts,
    meta: {
      requires: [USER_STATUS.LOGGED_IN, USER_STATUS.CONFIRM_EMAIL, USER_STATUS.COMPLETED],
      title: 'notifications.header',
      navigationPage: NAVIGATION_PAGES.ALERTS,
      isNetwork: true,
    },
  },
  {
    path: '/drive',
    name: 'Drive',
    component: Drive,
    meta: {
      requires: [USER_STATUS.LOGGED_IN, USER_STATUS.CONFIRM_EMAIL, USER_STATUS.COMPLETED],
    },
    children: [
      {
        path: '',
        name: 'DriveMy',
        component: DriveMain,
        meta: {
          title: 'drive.header.title',
          navigationPage: NAVIGATION_PAGES.DRIVE,
          customTitle: true,
        },
      },
      {
        path: 'network',
        name: 'DriveNetwork',
        component: DriveNetwork,
        meta: {
          title: 'drive.network.header.title',
          navigationPage: NAVIGATION_PAGES.NETWORK,
          isNetwork: true,
          hideAppButton: true,
        },
      },
      {
        path: 'case/create',
        name: 'DriveCaseCreate',
        component: DriveCreateCase,
        meta: {
          hideAppButton: true,
          hideHeaderSearch: true,
          hideBottomNav: true,
          hideFooter: true,
          // backText: 'drive.create.case.backtext',
          navigationPage: NAVIGATION_PAGES.CASE_CREATE,
          title: 'drive.create.case.title',
        },
      },
      {
        path: 'case/:id/edit',
        name: 'DriveCaseEdit',
        component: DriveCaseEdit,
        meta: {
          customTitle: true,
          hideAppButton: true,
          hideBottomNav: true,
          hideFooter: true,
          // backText: 'drive.edit.backtext',
          backArrow: true,
          navigationPage: NAVIGATION_PAGES.CASE_EDIT,
          hideHeaderSearch: true,
        },
      },
      {
        path: 'case/my/:id/view',
        name: 'DriveMyView',
        component: DriveCaseView,
        meta: {
          customTitle: true,
          hideAppButton: true,
          hideBottomNav: true,
          navigationPage: NAVIGATION_PAGES.CASE_VIEW,
          hideHeaderSearch: true,
          // backText: 'drive.view.case.backtext',
          backArrow: true,
          autoSave: true,
        },
      },
      {
        path: 'case/network/:id/view',
        name: 'DriveNetworkView',
        component: DriveCaseView,
        meta: {
          customTitle: true,
          hideAppButton: true,
          hideBottomNav: true,
          navigationPage: NAVIGATION_PAGES.CASE_VIEW,
          caseNetworkView: true,
          hideHeaderSearch: true,
          // backText: 'drive.view.case.backtext',
          backArrow: true,
          isNetwork: true,
        },
      },
      {
        path: 'my/cases',
        name: 'DriveMyCases',
        component: DriveAllCases,
        meta: {
          title: 'drive.your.cases',
          // backText: 'drive.your.cases.backtext',
          backArrow: true,
          hideBottomNav: true,
          navigationPage: NAVIGATION_PAGES.DRIVE_CASES,
        },
      },
      {
        path: 'my/files',
        name: 'DriveMyMixed',
        component: DriveAllMixed,
        meta: {
          title: 'drive.your.files.header',
          // backText: 'drive.your.files.backtext',
          navigationPage: NAVIGATION_PAGES.DRIVE_FILES,
          backArrow: true,
          hideBottomNav: true,
        },
      },
      {
        path: 'network/folder/:id',
        name: 'DriveNetworkFolder',
        component: DriveFolder,
        meta: {
          title: 'Shared Folder',
          // backText: 'Back',
          navigationPage: NAVIGATION_PAGES.DRIVE_FOLDER,
          backArrow: true,
          hideBottomNav: true,
          customTitle: true,
          isNetwork: true,
        },
      },
      {
        path: 'folder/:id',
        name: 'DriveFolder',
        component: DriveFolder,
        meta: {
          title: 'Your Folder',
          // backText: 'Back',
          navigationPage: NAVIGATION_PAGES.DRIVE_FOLDER,
          backArrow: true,
          hideBottomNav: true,
          hideAppButton: false,
          customTitle: true,
        },
      },
      {
        path: 'my/photos',
        name: 'DriveMyPhotos',
        component: DriveAllPhotos,
        meta: {
          title: 'drive.your.photos.header',
          // backText: 'drive.your.photos.backtext',
          navigationPage: NAVIGATION_PAGES.DRIVE_PHOTOS,
          backArrow: true,
          hideBottomNav: true,
        },
      },
      {
        path: 'network/cases',
        name: 'DriveNetworkCases',
        component: DriveAllCases,
        meta: {
          title: 'drive.network.cases',
          // backText: 'drive.network.cases.backtext',
          backArrow: true,
          hideAppButton: true,
          hideBottomNav: true,
          navigationPage: NAVIGATION_PAGES.NETWORK_CASES,
          isNetwork: true,
        },
      },
      {
        path: 'public/cases',
        name: 'DrivePublicCases',
        component: DriveAllPublicCases,
        meta: {
          title: 'drive.public.cases',
          // backText: 'drive.public.cases.backtext',
          backArrow: true,
          hideAppButton: true,
          hideBottomNav: true,
          navigationPage: NAVIGATION_PAGES.PUBLIC_CASES,
          isPublicCases: true,
        },
      },
      {
        path: 'my/public/cases',
        name: 'DriveMyPublicCases',
        component: DriveAllPublicCases,
        meta: {
          title: 'drive.my.public.cases',
          // backText: 'drive.user.public.cases.backtext',
          backArrow: true,
          hideAppButton: true,
          hideBottomNav: true,
          navigationPage: NAVIGATION_PAGES.MY_PUBLIC_CASES,
          isMyPublicCases: true,
        },
      },
      {
        path: ':id/public/cases',
        name: 'DriveUserPublicCases',
        component: DriveAllPublicCases,
        meta: {
          title: 'drive.user.public.cases',
          // backText: 'drive.user.public.cases.backtext',
          backArrow: true,
          hideAppButton: true,
          hideBottomNav: true,
          navigationPage: NAVIGATION_PAGES.USER_PUBLIC_CASES,
          isUserPublicCases: true,
        },
      },
      {
        path: 'network/files',
        name: 'DriveNetworkFiles',
        component: DriveAllMixed,
        meta: {
          title: 'drive.network.files',
          // backText: 'drive.network.files.backtext',
          hideAppButton: true,
          navigationPage: NAVIGATION_PAGES.NETWORK_FILES,
          backArrow: true,
          hideBottomNav: true,
          isNetwork: true,
        },
      },
      {
        path: 'network/photos',
        name: 'DriveNetworkPhotos',
        component: DriveAllPhotos,
        meta: {
          title: 'drive.network.photos',
          // backText: 'drive.network.photos.backtext',
          hideAppButton: true,
          navigationPage: NAVIGATION_PAGES.NETWORK_PHOTOS,
          backArrow: true,
          hideBottomNav: true,
          isNetwork: true,
        },
      },
    ],
  },
  {
    path: '/messages',
    name: 'Messages',
    component: Messages,
    meta: {
      requires: [USER_STATUS.LOGGED_IN, USER_STATUS.CONFIRM_EMAIL, USER_STATUS.COMPLETED],
    },
    children: [
      {
        path: 'my',
        name: 'MessagesMy',
        component: MessagesMy,
        meta: {
          title: 'messages.title',
          // backText: 'messages.backtext',
          stepBackTo: '/',
          backArrow: true,
          hideBackStep: true,
          navigationPage: NAVIGATION_PAGES.MESSAGES_MY,
        },
      },
      {
        path: ':id',
        name: 'MessagesId',
        component: MessagesId,
        meta: {
          title: '',
          backArrow: true,
          // backText: 'messages.backtext',
          hideFooter: true,
          stepBackTo: '/messages/my',
          navigationPage: NAVIGATION_PAGES.MESSAGES_ID,
        },
      },
      {
        path: 'group/:id',
        name: 'MessagesGroupChatId',
        component: MessagesGroupId,
        meta: {
          backArrow: true,
          backText: 'messages.backtext',
          hideFooter: true,
          stepBackTo: '/messages/my',
          navigationPage: NAVIGATION_PAGES.MESSAGES_GROUP_CHAT_ID,
        },
      },
      {
        path: '',
        redirect: () => '/my',
      },
    ],
  },
  {
    path: '/settings',
    name: 'Settings',
    component: Settings,
    meta: {
      requires: [USER_STATUS.LOGGED_IN, USER_STATUS.CONFIRM_EMAIL, USER_STATUS.COMPLETED],
      navigationPage: NAVIGATION_PAGES.SETTINGS,
      title: 'settings.title',
    },
  },
  {
    path: '/settings/retrieve-apy-key',
    name: 'RetrieveApiKey',
    component: RetrieveApiKey,
    meta: { requires: [USER_STATUS.LOGGED_IN, USER_STATUS.CONFIRM_EMAIL, USER_STATUS.COMPLETED] },
  },
  {
    path: '/settings/change-password',
    name: 'Change Password',
    component: ChangePassword,
    meta: {
      backArrow: true,
      stepBackTo: '/settings',
      // backText: 'Back',
    },
  },
  {
    path: '/settings/notifications',
    name: 'Notifications',
    component: Notifications,
    meta: {
      backArrow: true,
      stepBackTo: '/settings',
      // backText: 'Back',
      requires: [USER_STATUS.LOGGED_IN, USER_STATUS.CONFIRM_EMAIL, USER_STATUS.COMPLETED],
    },
  },
  {
    path: '/settings/sharing-settings',
    name: 'Sharing Settings',
    component: SharingSettings,
    meta: {
      backArrow: true,
      stepBackTo: '/settings',
      // backText: 'Back',
      requires: [USER_STATUS.LOGGED_IN, USER_STATUS.CONFIRM_EMAIL, USER_STATUS.COMPLETED],
    },
  },
  {
    path: '/settings/help',
    name: 'Help',
    component: Help,
    meta: {
      backArrow: true,
      stepBackTo: '/settings',
      // backText: 'Back',
      requires: [USER_STATUS.LOGGED_IN, USER_STATUS.CONFIRM_EMAIL, USER_STATUS.COMPLETED],
      hideFooter: true,
    },
  },
  {
    path: '/settings/journey',
    name: 'Journey',
    component: Journey,
    meta: {
      backArrow: true,
      stepBackTo: '/settings',
      // backText: 'Back',
      requires: [USER_STATUS.LOGGED_IN, USER_STATUS.CONFIRM_EMAIL, USER_STATUS.COMPLETED],
      hideFooter: true,
    },
  },
  {
    path: '/payment',
    name: 'Payment',
    component: Payment,
    meta: {
      requires: [USER_STATUS.LOGGED_IN, USER_STATUS.CONFIRM_EMAIL, USER_STATUS.COMPLETED],
      navigationPage: NAVIGATION_PAGES.PAYMENT,
    },
  },
  {
    path: '/404',
    name: 'Error404',
    component: Error404,
    meta: {
      hideFooter: true,
    },
  },
  {
    path: '/403',
    name: 'Error403',
    component: Error403,
    meta: {
      hideFooter: true,
    },
  },
  {
    path: '/deploy',
    name: 'ErrorDeploy',
    component: ErrorDeploy,
    meta: {
      hideFooter: true,
    },
  },
  {
    path: '/no-status',
    name: 'ErrorNoStatus',
    component: ErrorNoStatus,
    meta: {
      hideFooter: true,
    },
  },
  {
    path: '/public/case/:publicUrl/',
    name: 'DriveCasePublicView',
    component: DriveCasePublicView,
    meta: {
      customTitle: true,
      hideAppButton: false,
      hideBottomNav: true,
      navigationPage: NAVIGATION_PAGES.CASE_VIEW,
      hideHeaderSearch: true,
      isUserPublicCase: true,
      // backText: 'drive.view.case.backtext',
      backArrow: true,
      autoSave: true,
    },
  },
  {
    path: '/join',
    name: 'Join',
    component: Join,
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: () => '/404',
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.onError((error) => {
  if (/ChunkLoadError:.*failed./i.test(error.message)) {
    window.location.reload();
  } else if (/Loading.*chunk.*failed./i.test(error.message)) {
    window.location.reload();
  }
});
router.beforeEach((to, from, next) => {
  MonitoringService.routingStarted();

  const mainStore = useMainStore();
  // mainStore.$state.user = user;
  // const store = useStore();

  function navigateByToken() {
    /**
     * function to handle login with token param in URL
     * */
    AuthService.loginByToken({ token: to.query.st?.toString() } as IToken)
      .then((response) => {
        if (response.results.user?.registrationState === REGISTRATION_STATE.NOT_REGISTERED) {
          next('/registration/healthcare');
        } else if (response.results.user?.registrationState === REGISTRATION_STATE.CONFIRM_PHONE_NUMBER) {
          next('/registration/step-7');
        } else {
          next();
        }
      })
      .catch(() => {
        next('/login');
      });
  }

  function navigate() {
    if (to.meta.requires) {
      const requires = to.meta.requires as USER_STATUS[];
      const userStatus = mainStore.$state.user.status;

      if (requires.includes(userStatus)) {
        next();
      } else if (userStatus === USER_STATUS.NOT_REGISTERED) {
        next('/registration/healthcare');
      } else if (userStatus === USER_STATUS.CONFIRM_PHONE_NUMBER) {
        next('/registration/step-7');
      } else if (userStatus === USER_STATUS.CONFIRM_EMAIL) {
        next('/email-confirm');
      } else {
        next('/login');
      }
    } else {
      next();
    }
  }

  function navigateToLogin() {
    const userStatus = mainStore.$state.user.status;
    if (userStatus === USER_STATUS.LOGGED_IN) {
      next('/');
    } else if (userStatus === USER_STATUS.CONFIRM_EMAIL) {
      next();
    } else {
      next();
    }
  }

  if (from.name === 'DriveMyView' && to.name === 'DriveCaseCreate') {
    router.go(-1);
  } else if (to.query.st?.toString()) {
    navigateByToken();
  } else if (to.meta.requires) {
    if (LocalStorageService.getAuthToken()) {
      if (mainStore.$state.user.status) {
        navigate();
      } else {
        UserService.fetchAndStoreUser().then(() => navigate());
      }
    } else {
      LocalStorageService.removeGmtId();
      next('/login');
    }
  } else if (to.path === '/login' || to.path === '/registration' || to.path === '/') {
    if (LocalStorageService.getAuthToken()) {
      if (mainStore.$state.user.status) {
        navigateToLogin();
      } else {
        UserService.fetchAndStoreUser().then(() => navigateToLogin());
      }
    } else {
      LocalStorageService.removeGmtId();
      next();
    }
  } else {
    next();
  }
});

export default router;
